import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export enum PaymentIntentStatus {
    canceled = 'canceled',
    processing = 'processing',
    requiresAction = 'requiresAction',
    requiresCapture = 'requiresCapture',
    requiresConfirmation = 'requiresConfirmation',
    requiresPaymentMethod = 'requiresPaymentMethod',
    succeeded = 'succeeded'
}

export enum SetupFutureUsage {
    offSession = 'offSession',
    onSession = 'onSession'
}

export type PaymentIntent = {
    id: string,
    amount: number
    automaticPaymentMethods: {
        enabled: boolean
    }
    created: number
    currency: string
    customerId: string
    description: string
    clientSecret: string
    paymentMethod: string
    status: PaymentIntentStatus
    setupFutureUsage: SetupFutureUsage
}


export interface IPaymentIntentTableColumn extends ITableColumn {
    render?: (item: PaymentIntent) => ReactNode;
}


export type ListPaymentIntents = {
    listPaymentIntents: { items: PaymentIntent[], nextToken?: string }
}

export type GetPaymentIntent = {
    getPaymentIntent: PaymentIntent
}

export type CreatePaymentIntent = {
    createPaymentIntent: PaymentIntent
}

export type UpdatePaymentIntent = {
    updatePaymentIntent: PaymentIntent
}

export type DeletePaymentIntent = {
    deletePaymentIntent: string
}
